var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUseCase31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 73.3327C75 74.6588 74.4732 75.9305 73.5355 76.8682C72.5978 77.8059 71.3261 78.3327 70 78.3327H10C8.67392 78.3327 7.40215 77.8059 6.46447 76.8682C5.52678 75.9305 5 74.6588 5 73.3327V43.3327C5 42.0066 5.52678 40.7348 6.46447 39.7971C7.40215 38.8595 8.67392 38.3327 10 38.3327H26.6667C28.7764 38.2183 30.7839 37.3868 32.3567 35.976L36.6667 31.666H56.6667L60.9767 35.976C62.5495 37.3868 64.5569 38.2183 66.6667 38.3327H70C71.3261 38.3327 72.5978 38.8595 73.5355 39.7971C74.4732 40.7348 75 42.0066 75 43.3327V73.3327Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 38.3327V34.9993C11.6665 34.1153 12.0177 33.2674 12.6428 32.6423C13.2679 32.0172 14.1158 31.666 14.9998 31.666H18.3332C19.2172 31.666 20.0651 32.0172 20.6902 32.6423C21.3153 33.2674 21.6665 34.1153 21.6665 34.9993V38.3327",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 55C19.4279 55 21.6665 52.7614 21.6665 50C21.6665 47.2386 19.4279 45 16.6665 45C13.9051 45 11.6665 47.2386 11.6665 50C11.6665 52.7614 13.9051 55 16.6665 55Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3333 65.0007C52.9357 65.0007 56.6667 61.2697 56.6667 56.6673C56.6667 52.0649 52.9357 48.334 48.3333 48.334C43.731 48.334 40 52.0649 40 56.6673C40 61.2697 43.731 65.0007 48.3333 65.0007Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3335 71.666C56.6178 71.666 63.3335 64.9503 63.3335 56.666C63.3335 48.3817 56.6178 41.666 48.3335 41.666C40.0492 41.666 33.3335 48.3817 33.3335 56.666C33.3335 64.9503 40.0492 71.666 48.3335 71.666Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6668 1.66602H31.6668C29.8259 1.66602 28.3335 3.1584 28.3335 4.99935V18.3327C28.3335 20.1736 29.8259 21.666 31.6668 21.666H61.6668C63.5078 21.666 65.0002 20.1736 65.0002 18.3327V4.99935C65.0002 3.1584 63.5078 1.66602 61.6668 1.66602Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 8.33398H35V15.0007H58.3333V8.33398Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3335 21.666L36.6668 31.666",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 21.666L56.6665 31.666",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseCase31);
export default __webpack_public_path__ + "static/media/useCase3_1.8790ab1c9a1bca2e75db92d2dc10a3bb.svg";
export { ForwardRef as ReactComponent };